import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import app from './module/app'
import agent from './module/agent'
import machine from './module/machine'
import company from './module/company'
import coupon from './module/coupon'
import site from './module/site'
import charge from './module/charge'
import repair from './module/repair'
import meter from './module/meter'
import setting from './module/setting'
import recharge from './module/recharge'
import invoice from './module/invoice'
import data from './module/data'
import screen from './module/screen'
import job from './module/job'
import code from './module/code'
import web from './module/web'
import notice from './module/notice'
import role from './module/role'
import version from './module/version'
import safety from './module/safety'
import payment from './module/payment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  getters: {

  },
  actions: {

  },
  mutations: {
    //
  },
  modules: {
    app,
    user,
    agent,
    machine,
    company,
    coupon,
    site,
    charge,
    repair,
    meter,
    setting,
    recharge,
    invoice,
    data,
    screen,
    job,
    code,
    web,
    notice,
    role,
    version,
    safety,
    payment
  }
})
